import { CellContext } from "@tanstack/react-table";
import { WorkspaceAssignment } from "@common/types/workspace";
import { useMemo } from "react";
import { TeamList } from "../../TeamList";
import { ClientDetailsRow } from "../clientViewConfig";

export const TeamCell = ({
    getValue,
    row,
}: CellContext<ClientDetailsRow, WorkspaceAssignment[]>) => {
    const team = useMemo(
        () =>
            getValue().sort((a, b) => {
                const aMatches =
                    a.organizationId === row.original.workspace.organizationId;
                const bMatches =
                    b.organizationId === row.original.workspace.organizationId;
                if (aMatches && !bMatches) {
                    return -1;
                }
                if (!aMatches && bMatches) {
                    return 1;
                }
                return 0;
            }),
        [getValue, row.original.workspace.organizationId],
    );

    return <TeamList team={team} />;
};
